import _defineProperty from "@babel/runtime/helpers/defineProperty";

/** @jsx jsx */
import EditorDoneIcon from '@atlaskit/icon/glyph/editor/done';
import { N900, N0, N50 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { css, jsx } from '@emotion/react';
import { ANALYTICS_HOVER_DELAY } from '../constants';
import { messages } from '../i18n';
const buttonStyles = css`
  height: 24px;
  width: 24px;
  background: ${token('color.background.neutral', N900)};
  padding: 0;
  border-radius: 4px;
  border: 1px solid ${token('color.border', N0)};
  cursor: pointer;
  display: block;
  box-sizing: border-box;
  overflow: hidden;
`;
const buttonWrapperStyles = css`
  border: 1px solid transparent;
  margin: 0 2px;
  font-size: 0;
  display: flex;
  align-items: center;
  padding: 1px;
  border-radius: 6px;
  &:hover {
    border: 1px solid ${token('color.border', N50)};
  }
`;
export default class Color extends PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "hoverStartTime", 0);

    _defineProperty(this, "onMouseEnter", () => {
      this.hoverStartTime = Date.now();
    });

    _defineProperty(this, "onMouseLeave", () => {
      const {
        onHover
      } = this.props;
      const delay = Date.now() - this.hoverStartTime;

      if (delay >= ANALYTICS_HOVER_DELAY && onHover) {
        onHover(this.props.value);
      }

      this.hoverStartTime = 0;
    });

    _defineProperty(this, "onMouseDown", e => {
      e.preventDefault();
    });

    _defineProperty(this, "onClick", e => {
      const {
        onClick,
        value
      } = this.props;
      e.preventDefault();
      onClick(value);
    });
  }

  render() {
    const {
      tabIndex,
      backgroundColor,
      isSelected,
      borderColor,
      value,
      setRef
    } = this.props;
    const borderStyle = `1px solid ${borderColor}`;
    return jsx("span", {
      css: buttonWrapperStyles
    }, jsx(FormattedMessage, messages[`${value}Color`], labels => jsx("button", {
      css: buttonStyles,
      onClick: this.onClick,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onMouseDown: this.onMouseDown,
      tabIndex: tabIndex,
      className: `${isSelected ? 'selected' : ''}`,
      title: labels[0] // button element does not support aria-selected.
      // For button selected (to be precise pressed) or not
      //  use aria-pressed as per
      // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
      ,
      "aria-pressed": isSelected,
      style: {
        backgroundColor: backgroundColor || 'transparent',
        border: borderStyle
      },
      ref: setRef
    }, isSelected && jsx(EditorDoneIcon, {
      primaryColor: borderColor,
      label: labels[0]
    }))));
  }

  componentWillUnmount() {
    this.hoverStartTime = 0;
  }

}